<template>
    <div>
      <carousel :perPage="1">
        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">reaching</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">straining</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">eyes tight</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">hand over hand</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">sifting collected images before blotting</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">tension held between the known and the lost</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">a moment that some might call an intersect between one of many threads</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">tying together echoes that refuse to give up their names but repeat until they are as regular as your every breath</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">and we look for a way to hold to frame and to remember</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">recalling and share between us</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">in the fading</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">bursts of</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p> &nbsp;</p>
            <p> &nbsp;</p>
            <p style = "font-size:1.5em">light</p>
            </div>
        </slide>
      </carousel>
    </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Between'
    }
  },
  mounted () {
    this.$emit('title-update', this.title)
  }
}
</script>

<style lang="css" scoped>
</style>
